var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.918,
    height: 17.948,
    viewBox: "0 0 17.918 17.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(0.149 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35473",
    "data-name": "Group 35473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18481",
    "data-name": "Path 18481",
    d: "M10,0a5.789,5.789,0,0,1,.893.287,2.669,2.669,0,0,1,1.549,2.386c.024.481.01.965,0,1.447a.688.688,0,1,1-1.375,0c-.006-.425,0-.85,0-1.275A1.388,1.388,0,0,0,9.6,1.379q-3.377,0-6.754,0A1.385,1.385,0,0,0,1.384,2.837q0,5.987,0,11.975a1.385,1.385,0,0,0,1.463,1.457q3.377,0,6.754,0A1.388,1.388,0,0,0,11.069,14.8c0-.408,0-.816,0-1.223a.691.691,0,1,1,1.377,0,16.274,16.274,0,0,1-.038,1.686,2.709,2.709,0,0,1-2.314,2.351.528.528,0,0,0-.094.033H2.451c-.193-.049-.391-.085-.578-.151A2.756,2.756,0,0,1,0,14.82Q0,9.264,0,3.707c0-.345-.014-.69.005-1.034A2.678,2.678,0,0,1,1.559.287,5.783,5.783,0,0,1,2.451,0Z",
    transform: "translate(0)",
    fill: "#dee4ff",
    stroke: "#dee4ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18482",
    "data-name": "Path 18482",
    d: "M206.939,174.326a2.533,2.533,0,0,1-.791,1.163c-.419.4-.819.822-1.235,1.226a.663.663,0,0,1-.81.1.647.647,0,0,1-.33-.729.989.989,0,0,1,.237-.406c.326-.346.671-.676,1.045-1.048h-.238q-3.972,0-7.945,0a.755.755,0,0,1-.6-.216.656.656,0,0,1-.146-.719.665.665,0,0,1,.586-.441,1.875,1.875,0,0,1,.207,0h8.109c-.05-.057-.079-.1-.113-.13-.324-.326-.657-.643-.971-.979a.682.682,0,0,1,.347-1.148.627.627,0,0,1,.605.166c.556.549,1.121,1.09,1.648,1.666a3.273,3.273,0,0,1,.392.735Z",
    transform: "translate(-189.32 -165.088)",
    fill: "#dee4ff",
    stroke: "#dee4ff",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.af61cb88cd329954295dc745956598eb.svg";
export { ForwardRef as ReactComponent };